import styled from 'styled-components';

export const Wrapper = styled.div`
  .content {
    p {
      margin: 0;
      padding: 0 0 10px;
    }
    ul {
      margin-left: 20px;
      list-style: disc;
    }
  }

  .buttonGroup {
    display: flex;
    gap: 10px;
    justify-content: center;

    button {
      width: 130px;
    }
  }
`;
